// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { PackageVersion, IPackageVersion } from "./Hardware.PackageVersion.gen";

export interface IVersionReport {
	packageVersions: IPackageVersion[] | undefined;

	id: string | undefined;

	deviceId: string | undefined;

	dateReported: string | undefined;

	$type?: string | undefined;
}
export class VersionReport {
	constructor(data?: IVersionReport) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.packageVersions = data.packageVersions ? data.packageVersions.map((p: any) => new PackageVersion(p)) : [];
		if (data.dateReported) { this.dateReported = new Date(data.dateReported); }
	}

	packageVersions: PackageVersion[] | undefined = [];

	id: string | undefined;

	deviceId: string | undefined;

	dateReported: Date | undefined = new Date();

	static $type: string = "CoreApi.Models.Hardware.VersionReport, ";
	$type?: string | undefined = VersionReport.$type;
}

